<script>
export default {
    name: 'IconAdd'
}
</script>
<template>
    <svg
        class="base-icon icon-add"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M35 12v17h17v6H35v17h-6V35H12v-6h17V12h6z"
            fill="currentColor"
            fill-rule="evenodd"
        />
    </svg>
</template>
